export interface InternshipCompanyContactPayload {
    id: number
    idPrakBetrieb: number
    Anrede: string
    Vorname: string
    Nachname: string
    Telefon: string
    Mobil: string
    eMail: string
    Internet: string
}

export class InternshipCompanyContact {

    id: number
    idPrakBetrieb: number
    Anrede: string
    Vorname: string
    Nachname: string
    Telefon: string
    Mobil: string
    eMail: string
    Internet: string

    constructor(data: InternshipCompanyContactPayload) {
        this.id = data.id
        this.idPrakBetrieb = data.idPrakBetrieb
        this.Anrede = data.Anrede
        this.Vorname = data.Vorname
        this.Nachname = data.Nachname
        this.Telefon = data.Telefon
        this.Mobil = data.Mobil
        this.eMail = data.eMail
        this.Internet = data.Internet
    }

    fill(data: InternshipCompanyContactPayload): this {
        this.id = data.id
        this.idPrakBetrieb = data.idPrakBetrieb
        this.Anrede = data.Anrede
        this.Vorname = data.Vorname
        this.Nachname = data.Nachname
        this.Telefon = data.Telefon
        this.Mobil = data.Mobil
        this.eMail = data.eMail
        this.Internet = data.Internet
        return this
    }

    payload(): InternshipCompanyContactPayload {
        return {
            id: this.id,
            idPrakBetrieb: this.idPrakBetrieb,
            Anrede: this.Anrede,
            Vorname: this.Vorname,
            Nachname: this.Nachname,
            Telefon: this.Telefon,
            Mobil: this.Mobil,
            eMail: this.eMail,
            Internet: this.Internet,
        }
    }
}